import {Action, Catalog} from '../../../../common/types/common';
import {FieldSummary} from '../../../types/mx/epics';
import {POSSummaryDTO} from '../types/epics';
import {POSViewFieldErrorState} from '../types/reducers';
import {Group} from '../types/types';

export const CHANGE_POS_DATA_STEP_GROUP_NAME: Action = {
    name: 'CHANGE_POS_DATA_STEP_GROUP_NAME',
    action: (group: Catalog, error: string = null) => ({
        group, error,
        type: CHANGE_POS_DATA_STEP_GROUP_NAME.name
    })
};

export const GET_POS_GROUPS: Action = {
    name: 'GET_POS_GROUPS',
    action: (input: string, updateData: Function) => ({
        input, updateData,
        type: GET_POS_GROUPS.name
    })
};

export const GOT_POS_GROUPS: Action = {
    name: 'GOT_POS_GROUPS',
    action: (groups: Catalog[], updateData: Function) => ({
        groups, updateData,
        type: GOT_POS_GROUPS.name
    })
};

export const CHANGE_POS_REQUIRED_FIELDS: Action = {
    name: 'CHANGE_POS_REQUIRED_FIELDS',
    action: (requiredFields: boolean) => ({
        requiredFields,
        type: CHANGE_POS_REQUIRED_FIELDS.name
    })
};

export const SET_POS_DATA_STEP_STATE_ACTION: Action = {
    name: 'SET_POS_DATA_STEP_STATE_ACTION',
    action: (fieldSummary: FieldSummary<POSSummaryDTO, POSViewFieldErrorState>) => ({
        fieldSummary,
        type: SET_POS_DATA_STEP_STATE_ACTION.name
    })
};

export const MIGRATE_POS_REQUEST_ACTION: Action = {
    name: 'MIGRATE_POS_REQUEST_ACTION',
    action: (targetGroup: Group) => ({
        targetGroup,
        type: MIGRATE_POS_REQUEST_ACTION.name
    })
};

export const MIGRATE_POS_SUCCESS_ACTION: Action = {
    name: 'MIGRATE_POS_SUCCESS_ACTION',
    action: () => ({
        type: MIGRATE_POS_SUCCESS_ACTION.name
    })
};